import { Link } from 'react-router-dom';
import { Check, ArrowUpRight } from 'lucide-react';
import { SectionHeading } from '../components/SectionHeading';
import { Reveal } from '../components/Reveal';
import { courses } from '../data/content';

export const CoursesPreview = () => (
  <section data-testid="courses-preview-section" className="grain relative overflow-hidden bg-forest">
    <div
      className="pointer-events-none absolute -right-40 -top-40 h-[460px] w-[460px] rounded-full bg-gold/15 blur-[120px]"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
      <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
        <SectionHeading
          dark
          chapter="06"
          eyebrow="Digital Marketing Courses"
          title="Build Skills That Move You Forward."
          copy="Practical digital marketing courses designed to help you understand digital marketing, develop valuable skills, and apply them to real business challenges."
        />
        <Reveal delay={0.2}>
          <Link to="/courses" data-testid="courses-view-all" className="btn-outline-light shrink-0">
            View All Courses <ArrowUpRight size={16} />
          </Link>
        </Reveal>
      </div>
      <div className="mt-14 grid gap-5 lg:grid-cols-3">
        {courses.map((c, i) => (
          <Reveal key={c.slug} delay={i * 0.1} className="h-full">
            <div
              data-testid={`course-card-${c.slug}`}
              className={`card-lift flex h-full flex-col rounded-2xl p-8 ${
                c.featured
                  ? 'border-2 border-forest bg-white shadow-[0_36px_80px_-40px_rgba(0,0,0,0.55)]'
                  : 'border-2 border-white bg-white'
              }`}
            >
              <span
                className={`mb-6 inline-flex w-fit rounded-full px-3.5 py-1 font-mono text-[10px] uppercase tracking-[0.22em] ${
                  c.featured ? 'bg-forest text-white' : 'border-2 border-forest/30 text-forest'
                }`}
              >
                {c.badge}
              </span>
              <h3 className="font-display text-2xl font-bold leading-snug text-ink">{c.name}</h3>
              <div className="mt-4 flex items-baseline gap-3">
                <span className="font-display text-4xl font-bold text-forest" data-testid={`course-price-${c.slug}`}>
                  {c.price}
                </span>
                {c.priceSuffix && <span className="text-sm text-white">{c.priceSuffix}</span>}
                {c.oldPrice && (
                  <span className="text-sm text-ink line-through" data-testid={`course-oldprice-${c.slug}`}>
                    {c.oldPrice}
                  </span>
                )}
              </div>
              <p className="mt-4 text-sm leading-relaxed text-ink">{c.description}</p>
              <ul className="mt-6 flex-1 space-y-2.5">
                {c.points.map((p) => (
                  <li key={p} className="flex items-start gap-2.5 text-sm text-ink">
                    <Check size={15} className="mt-0.5 shrink-0 text-forest" strokeWidth={3} />
                    {p}
                  </li>
                ))}
              </ul>
              <Link
                to="/courses"
                data-testid={`course-enroll-${c.slug}`}
                className="btn-forest mt-8 w-full"
              >
                Enroll in a Course
              </Link>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
